
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SaveAsDialogComponent } from './save-as-dialog/save-as-dialog.component';
import { CopyTemplateDialogComponent } from './copy-template-dialog/copy-template-dialog.component';
import { SlotDialogComponent } from './slot-dialog/slot-dialog.component';
import { AssignTemplateDialogComponent } from './assign-template-dialog/assign-template-dialog.component';
import { MutationObserverDirective } from './directives';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatChipsModule } from '@angular/material/chips';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatControlsModule } from 'src/app/MatControls.module';


@NgModule({
  declarations: [
    SaveAsDialogComponent,
    CopyTemplateDialogComponent,
    SlotDialogComponent,
    MutationObserverDirective,
    AssignTemplateDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatControlsModule,
    MatChipsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule
  ],
  entryComponents: [
    SaveAsDialogComponent,
    CopyTemplateDialogComponent,
    SlotDialogComponent,
    AssignTemplateDialogComponent,
    CopyTemplateDialogComponent
  ]
})
export class CalTemplatesModule { }
